import { randomNum } from '@hglobal/common';

import { CreateRequestRes, FinancialRequestStatus } from '../../../models';

export function getRequestDetailsMock(id: number): CreateRequestRes {
  return {
    request: {
      requestId: id,
      requestIdHash: id.toString(),
      requestType: ['message', 'updatePaymentMethod'][randomNum(1)],
      date: new Date(),
      status: [
        FinancialRequestStatus.New,
        FinancialRequestStatus.InProgress,
        FinancialRequestStatus.Completed,
        FinancialRequestStatus.Rejected,
        FinancialRequestStatus.Canceled,
      ][randomNum(4)],
    },
  };
}
